$(document).ready(function () {

    $('.partners').mousemove(function (event) {
        $('.partnerbar-odd').css({
            'transform': 'translateX(' + (event.pageX - (window.innerWidth / 2)) * 0.25 + 'px)',
        });
        $('.partnerbar-even').css({
            'transform': 'translateX(' + (event.pageX - (window.innerWidth / 2)) * -0.25 + 'px)',
        });
    });

    $('.partners').mouseout(function () {
        $('.partnerbar-odd').css({
            'transform': 'translateX(0)',
        });
        $('.partnerbar-even').css({
            'transform': 'translateX(0)',
        });
    });

});



// WEBPACK FOOTER //
// ./scripts/modules/mousemove.js